import React from "react"

import { GridColDef } from "@mui/x-data-grid"

import {
    OrderType,
    PaginatedResponse,
    SearchFilter,
    MicrojobberRequest
} from "models"
import { SbPaginatedDatagrid } from "components/commons"
import getMicrojobJobsTableColumns from "./microjob-jobs-table-columns"


interface MicrojobJobsTableProps {
    handleCallback: (data: MicrojobberRequest) => void
    openModal: (row: any) => void
    data: PaginatedResponse<any> | null
}
interface MicrojobJobsTableState {
    pagination: SearchFilter
}
export class MicrojobJobsTable extends React.Component<MicrojobJobsTableProps, MicrojobJobsTableState> {
    private readonly columns: GridColDef[]

    constructor(props: MicrojobJobsTableProps) {
        super(props)
        this.columns = getMicrojobJobsTableColumns(props)
        this.state = {
            pagination: {
                pageSize: 10,
                pageId: 0,
                orderBy: "id",
                orderType: OrderType.ASCENDING,
            },
        }
    }

    componentDidMount() {
        this.props.handleCallback(this.state.pagination as MicrojobberRequest)
    }

    private onPaginationChanged = (pageId: number, pageSize: number): void => {
        this.setState(
            () => ({
                pagination: {
                    ...this.state.pagination,
                    pageSize: pageSize,
                    pageId: pageId,
                },
            }),
            () => this.props.handleCallback(this.state.pagination as MicrojobberRequest)
        )
    }

    private onSortChanged = (orderBy: string | null, orderType: OrderType | null): void => {
        // this.setState(
        //     () => ({
        //         pagination: {
        //             pageSize: this.state.pagination.pageSize,
        //             pageId: this.state.pagination.pageId,
        //             orderBy: orderBy,
        //             orderType: orderType,
        //         },
        //     }),
        //     () => this.props.handleCallback(this.state.pagination as MicrojobberRequest)
        // )
    }

    render() {
        return (
            <SbPaginatedDatagrid
                columns={this.columns}
                data={this.props.data}
                pagination={this.state.pagination}
                onPaginationChanged={this.onPaginationChanged}
                onSortChanged={this.onSortChanged}
            />
        )
    }
}
